import { styled } from 'styled-system/jsx'

const FieldContainer = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
})

const FieldLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

const TagsRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    padding: '10px 12px',
    border: '1.5px solid',
    borderColor: '#E5E0F5',
    borderRadius: 'sm',
    backgroundColor: '#FFFFFF',
    minHeight: '48px',
    alignItems: 'center',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _focusWithin: {
      borderColor: 'quickpass.primary',
      boxShadow: '0 0 0 4px rgba(128, 84, 255, 0.12)',
    },
  },
})

const TagPill = styled('span', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: 'quickpass.surfaceCool',
    color: 'quickpass.primary',
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    paddingX: '12px',
    paddingY: '6px',
    borderRadius: 'pill',
  },
})

const TagRemoveButton = styled('button', {
  base: {
    background: 'transparent',
    border: 'none',
    color: 'quickpass.primary',
    cursor: 'pointer',
    padding: '0',
    fontSize: '16px',
    lineHeight: '1',
    fontWeight: '700',
    _hover: { color: 'quickpass.warmth' },
  },
})

const TagInput = styled('input', {
  base: {
    flex: '1',
    minWidth: '120px',
    border: 'none',
    outline: 'none',
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.ink',
    backgroundColor: 'transparent',
    _placeholder: { color: '#B8B0CC', opacity: '1' },
  },
})

const SuggestionRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    marginTop: '4px',
  },
})

const SuggestionChip = styled('button', {
  base: {
    background: 'transparent',
    border: '1.5px dashed',
    borderColor: '#E5E0F5',
    color: 'quickpass.inkSoft',
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '500',
    paddingX: '10px',
    paddingY: '4px',
    borderRadius: 'pill',
    cursor: 'pointer',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      color: 'quickpass.primary',
    },
    _disabled: {
      opacity: '0.4',
      cursor: 'not-allowed',
    },
  },
})

const HelperText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
  },
})

export {
  FieldContainer,
  FieldLabel,
  TagsRow,
  TagPill,
  TagRemoveButton,
  TagInput,
  SuggestionRow,
  SuggestionChip,
  HelperText,
}
